import React from 'react';
import { theme, GlobalStyles } from 'styles';
import { ThemeProvider } from 'styled-components';
import { NotFound, ScrollToTop } from 'components';
import {
  ConControl,
  ConPower,
  ConSensor,
  Container,
  Dashboard,
  Energy,
  House,
  HouseControl,
  HousePower,
  HouseSensor,
  Kma,
  Outdoor,
} from 'pages';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Layout } from 'layouts';
import { AlertContextProvider } from 'hooks/useAlertContext';

function App(props) {
  return (
    <ThemeProvider theme={theme}>
      <AlertContextProvider>
        <GlobalStyles />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/house" element={<House />}>
                <Route path="sensor" element={<HouseSensor />} />
                <Route path="control" element={<HouseControl />} />
                <Route path="power" element={<HousePower />} />
              </Route>
              <Route path="/container" element={<Container />}>
                <Route path="sensor" element={<ConSensor />} />
                <Route path="control" element={<ConControl />} />
                <Route path="power" element={<ConPower />} />
              </Route>
              <Route path="/outdoor" element={<Outdoor />} />
              <Route path="/energy" element={<Energy />} />
              <Route path="/kma" element={<Kma />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AlertContextProvider>
    </ThemeProvider>
  );
}

export default App;
